import axios from "axios";
export const state = {
    dashboard: {},
};
export const getters = {
    Dashboard: state => state.dashboard,
};

export const mutations = {
    SET_DASHBOARD(state, newValue) {
        state.dashboard = newValue
    },
   
};

export const actions = {
    fetchDashboardValues({ commit }) {
        axios.get('dashboard').then(sta => {
            commit('SET_DASHBOARD', sta.data)
        })
    },
};